<template>
  <Main>
    <v-container>
      <v-row justify="center">
        <v-col cols="12">
          <v-card class="pa-5">
            <strong>AAM - Add New Title</strong>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
                v-model="title"
                :rules="titleRules"
                label="Title"
                color="red darken-1"
                required
              ></v-text-field>
              <v-text-field
                v-model="titleDesc"
                :rules="titleDescRules"
                label="Title Desc"
                color="red darken-1"
                required
              ></v-text-field>
              <v-autocomplete
                v-model="type"
                :items="typeList"
                :loading="istypeListLoading"
                item-text="EMPLOYEE_TYPE_CODE"
                item-value="EMPLOYEE_TYPE_CODE"
                label="Type"
                color="red darken-1"
              ></v-autocomplete>
              <v-row>
                <!-- START DATE -->
                <v-col cols="6">
                  <v-menu
                    v-model="isShowStartDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="startDate"
                        label="Start Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="startDate"
                      @input="isShowStartDate = false"
                      color="red darken-1"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <!-- END DATE -->
                <v-col cols="6">
                  <v-menu
                    v-model="isShowEndDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="endDate"
                        label="End Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        color="red darken-1"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="endDate" @input="isShowEndDate = false">
                      <template>
                        <v-card-actions class="w-100 float-right">
                          <v-btn
                            small
                            flat
                            color="warning"
                            @click="
                              (endDate = new Date().toISOString().substr(0, 10)),
                                (isShowEndDate = false)
                            "
                            >Select Today</v-btn
                          >
                        </v-card-actions>
                      </template>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>

              <v-btn @click="confirmModal(submit)" color="warning" class="mr-4"
                >Submit</v-btn
              >
            </v-form>
          </v-card>

          <br />
          <v-card class="pa-5" shaped>
            <v-card-title>
              Title List
              <v-spacer></v-spacer>
              <v-text-field
                v-model="searchTitle"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="dtHeaders"
              :items="dtItems"
              :search="searchTitle"
              :loading="dtLoading"
              loading-text="Fetching Data..."
            >
              <template v-slot:item.edit="{ item }">
                <v-icon small class="mr-2" @click="editItem(item.titleId)"
                  >mdi-pencil</v-icon
                >
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- Start Validation Submit -->
    <v-dialog v-model="isOpenModalConfirm" max-width="500px">
      <v-card>
        <v-card-title class="headline">Are you Sure to Continue ?</v-card-title>

        <v-card-text
          >It will save input data to database. Please give confirmation before you
          continue.</v-card-text
        >

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="isOpenModalConfirm = false"
            >Cancel</v-btn
          >

          <v-btn color="green darken-1" text @click="methodAction">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Validation Submit -->
  </Main>
</template>

<script>
import Main from "@/Main.vue";
import moment from "moment";

const dtHeaders = [
  {
    text: "Title",
    value: "titleCode",
  },
  {
    text: "Title Desc",
    value: "titleDesc",
  },
  {
    text: "Type",
    value: "typeCode",
  },
  {
    text: "Start Date",
    value: "startDate",
  },
  {
    text: "End Date",
    value: "endDate",
  },
  {
    text: "Status",
    value: "status",
  },
  {
    text: "Edit",
    value: "edit",
    sortable: false,
  },
];

export default {
  components: {
    Main,
  },
  data() {
    return {
      methodAction: "",
      isOpenModalConfirm: false,
      isEdit: false,
      title: "",
      titleRules: [(v) => !!v || "Title is required"],
      titleDesc: "",
      titleDescRules: [(v) => !!v || "Title description is required"],
      startDate: moment().startOf("month").format("YYYY-MM-DD"),
      isShowStartDate: false,
      isShowStartDate: false,
      endDate: moment("4001-12-31").endOf("month").format("YYYY-MM-DD"),
      isEdit: false,
      isShowEndDate: false,
      isLoading: false,
      istypeListLoading: false,
      snackbarText: "",
      isShowSnackbar: false,
      valid: true,
      dtHeaders,
      searchTitle: "",
      dtItems: [],
      dtLoading: false,
      typeList: [],
      type: "",
    };
  },
  mounted() {
    this.populateDataTable();
    if (this.$route.params.titleId) {
      this.getStructureTitleById(this.$route.params.titleId);
    }
  },
  watch: {
    $route(to) {
      if (to.params.titleId) {
        this.getStructureTitleById(to.params.titleId);
      }
    },
  },
  methods: {
    confirmModal: function (method) {
      this.isOpenModalConfirm = true;
      this.methodAction = method;
    },
    submit() {
      const isValid = this.$refs.form.validate();
      this.isOpenModalConfirm = false;
      if (isValid == false) return;
      this.isLoading = true;
      const userData = JSON.parse(localStorage.getItem("userData"));
      let data = {
        titleCode: this.title,
        titleDesc: this.titleDesc,
        typeCode: this.type,
        startDate: this.startDate,
        endDate: this.endDate,
        userIdUpdate: userData.USER_ID,
        lastUpdate: moment().format("YYYY-MM-DD HH:mm:ss"),
      };

      //PROCEED TO EDIT
      if (this.$route.params.titleId) {
        data.titleId = this.$route.params.titleId;
        this.editStructureTitle(data);
        return;
      }

      this.$http
        .post("/structure/title/insert", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          if (!res.data.success || res.data.success == undefined) {
            console.log(res);
          }
          if (res.data.success) {
            this.isLoading = false;
            this.showSnackbar(res.data.data);
            this.title = "";
            this.titleDesc = "";
            this.type = "";
            this.$refs.form.resetValidation();
            this.populateDataTable();
          } else {
            this.isLoading = false;
            this.showSnackbar(res.data.data);
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
    populateDataTable() {
      this.dtLoading = true;
      this.istypeListLoading = true;
      this.$http
        .get("/structure/title/getType", {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          if (!res.data.success || res.data.success == undefined) {
            console.log(res);
          }
          let { data } = res.data;
          this.typeList = data;
          this.istypeListLoading = false;
        })
        .catch((err) => {
          this.istypeListLoading = false;
        });

      this.$http
        .get("/structure/title/select", {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          if (!res.data.success || res.data.success == undefined) {
            console.log(res);
          }
          this.dtLoading = false;
          let { data } = res.data;

          this.dtItems = data.map((obj) => {
            return {
              titleId: obj.EMPLOYEE_TITLE_ID,
              titleCode: obj.EMPLOYEE_TITLE_CODE,
              titleDesc: obj.EMPLOYEE_TITLE_DESC,
              typeCode: obj.TYPE_CODE,
              startDate: moment(obj.EMPLOYEE_TITLE_START_DATE).format("YYYY-MM-DD"),
              endDate: moment(obj.EMPLOYEE_TITLE_END_DATE).format("YYYY-MM-DD"),
              status: obj.STATUS,
            };
          });
        })
        .catch((err) => {
          this.dtLoading = false;
          console.log("error datatable", err.toString());
        });
    },
    editItem(titleId) {
      this.$router.push({
        path: `/structure/title/${titleId}`,
      });
    },
    getStructureTitleById(id) {
      window.scrollTo(0, 0);
      this.isLoading = true;
      this.$http
        .get(`/structure/title/${id}`, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          if (!res.data.success || res.data.success == undefined) {
            console.log(res);
          }
          this.isLoading = false;
          const { data } = res.data;

          console.log(data);
          this.title = data[0].EMPLOYEE_TITLE_CODE;
          this.titleDesc = data[0].EMPLOYEE_TITLE_DESC;
          this.type = data[0].TYPE_CODE;
          this.startDate = moment(data[0].EMPLOYEE_TITLE_START_DATE).format("YYYY-MM-DD");
          this.endDate = moment(data[0].EMPLOYEE_TITLE_END_DATE).format("YYYY-MM-DD");
        })
        .catch((err) => {
          this.isLoading = false;
          console.log("error getStructureTitleById", err.toString());
        });
    },
    editStructureTitle(data) {
      this.$http
        .post("/structure/title/update", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          if (!res.data.success || res.data.success == undefined) {
            console.log(res);
          }
          if (res.data.success) {
            this.isLoading = false;
            this.showSnackbar("Edit Success");
            this.$router.push({
              name: "Title",
            });
            this.title = "";
            this.titleDesc = "";
            this.type = "";
            this.$refs.form.resetValidation();
            this.populateDataTable();
          } else {
            this.isLoading = false;
            this.showSnackbar(res.data.message);
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.showSnackbar(err.toString());
        });
    },
  },
};
</script>
